export enum EventType {
    None,
    Added,
    Edited,
    Removed,
    Selected,
    UnitChanged,
}

export interface SessionEvent {
    type: EventType;
   session?: any;
   sessions?: any;
  practiceSessionScheduleId?: string;
}
